export class PhraseFormDTOBuilder {}
PhraseFormDTOBuilder.build = function (id, description, help) {
  const phraseFormDTO = {
    id,
    description,
    help
  };
  return phraseFormDTO;
};
